import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { providerInitialValues } from 'components/organisms/forms/providers/ProviderForm';
import { useHasPermission } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useDeleteProvider, useGetProvider } from 'services/providers';

const Provider = () => {
  const providerId = useCustomParamId('id', 'settings/provider');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasPermission = useHasPermission();

  const provider = useGetProvider(providerId);

  const removeProvider = useDeleteProvider();

  const onRemoveProvider = async (actions: PopupActions) => {
    await removeProvider.mutateAsync(providerId, {
      onSuccess: () => {
        actions.close();
        navigate('settings/provider');
      },
    });
  };

  return (
    <Form.Provider
      topbarContent={
        <div className='flex w-full justify-end items-center'>
          {hasPermission('ProvidersPermissionsLIST**', 2) &&
            !provider.data?.isPredefined && (
              <Button
                isClear
                onlyIcon
                onClick={() => {
                  provider && navigate(`/settings/provider/edit/${providerId}`);
                }}>
                <Button.Icon icon={<PiPencilSimpleLine />} />
              </Button>
            )}
          {hasPermission('ProvidersPermissionsLIST**', 4) &&
            !provider.data?.isPredefined && (
              <MagellanPopups.DeleteWarning
                name={provider.data?.name}
                onRemove={onRemoveProvider}
              />
            )}
        </div>
      }
      tittle={provider.data?.name}
      onSubmit={() => {}}
      initialValues={
        provider.data
          ? middleware.provider.queryToForm(provider.data)
          : providerInitialValues
      }
      i18nextPrefix='provider'
      status={{ displayMode: true, isLoading: provider.isLoading }}
    />
  );
};

export default Provider;
